import { Component, OnInit } from '@angular/core';
import { ActivatedRouteSnapshot, Router, NavigationEnd } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { filter } from 'rxjs/operators';
import { UserSharedService } from '../core/users/user.service';

interface Breadcrumb {
    label: string;
    url?: string;
}

@Component({
    selector: 'app-breadcrumb',
    templateUrl: './app.breadcrumb.component.html'
})
export class AppBreadcrumbComponent implements OnInit {

    private readonly _breadcrumbs$ = new BehaviorSubject<Breadcrumb[]>([]);
    readonly breadcrumbs$ = this._breadcrumbs$.asObservable();

    constructor(private router: Router,
        private userService: UserSharedService
    ) { }

    ngOnInit(): void {
        // Build breadcrumb on initial load
        this.buildBreadcrumb(this.router.routerState.snapshot.root);

        // Listen for navigation events to update breadcrumb
        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd)
        ).subscribe(() => {
            this.buildBreadcrumb(this.router.routerState.snapshot.root);
        });
    }

      get homeLink(): string {
        return this.userService.userRole === 'STAFF' ? '/dashboard/overview' : '/dashboard';
    }

    private buildBreadcrumb(route: ActivatedRouteSnapshot) {
        const breadcrumbs: Breadcrumb[] = [];
        this.addBreadcrumb(route, [], breadcrumbs);
        this._breadcrumbs$.next(breadcrumbs);
    }

    private addBreadcrumb(route: ActivatedRouteSnapshot, parentUrl: string[], breadcrumbs: Breadcrumb[]) {
        const routeUrl = parentUrl.concat(route.url.map(url => url.path));
        const breadcrumb = route.data['breadcrumb'];
        const parentBreadcrumb = route.parent && route.parent.data ? route.parent.data['breadcrumb'] : null;

        if (breadcrumb && breadcrumb !== parentBreadcrumb) {
            breadcrumbs.push({
                label: breadcrumb,
                url: '/' + routeUrl.join('/')
            });
        }

        if (route.firstChild) {
            this.addBreadcrumb(route.firstChild, routeUrl, breadcrumbs);
        }
    }
}
